import { NavItemModel } from '../../common';

export const CHECKOUT_CART_ROUTE_NAME: string = 'cart';
export const CHECKOUT_CART_ROUTE_PATH: string = 'cart';
export const checkoutCartNavItem: NavItemModel = {
  name: CHECKOUT_CART_ROUTE_NAME,
  url: `/${CHECKOUT_CART_ROUTE_PATH}`,
  label: 'Warenkorb',
  icon: {
    name: 'cart-shopping',
    family: 'light',
  },
};

export const CHECKOUT_OVERVIEW_ROUTE_NAME: string = 'checkout';
export const CHECKOUT_OVERVIEW_ROUTE_PATH: string = 'checkout';
export const checkoutOverviewNavItem: NavItemModel = {
  name: CHECKOUT_OVERVIEW_ROUTE_NAME,
  url: `/${CHECKOUT_OVERVIEW_ROUTE_PATH}`,
  label: 'Checkout',
};

export const CHECKOUT_CONFIRMATION_ROUTE_NAME: string = 'checkout-success';
export const CHECKOUT_CONFIRMATION_ROUTE_PATH: string = 'checkout-success';
export const checkoutConfirmationNavItem: NavItemModel = {
  name: CHECKOUT_CONFIRMATION_ROUTE_NAME,
  url: `/${CHECKOUT_CONFIRMATION_ROUTE_PATH}`,
  label: 'Bestellbestätigung',
};

export const checkoutNavigationItems: NavItemModel[] = [
  checkoutCartNavItem,
  checkoutOverviewNavItem,
  checkoutConfirmationNavItem,
];
